import { z } from 'zod'
import { baseSchema } from './base'

export const formItemSchema = baseSchema.extend({
  label: z.string(),
  name: z.string(),
  preserve: z.boolean().optional(),
  span: z.number().optional().describe('栅格占位格数'),
  rules: z
    .object({
      type: z.enum(['string', 'number', 'boolean', 'integer']).optional().describe('字段数据类型'),
      required: z.boolean().optional().describe('是否为必选字段'),
      message: z.string().optional().describe('错误信息，不设置时会通过模板自动生成'),
      min: z
        .number()
        .optional()
        .describe('必须设置 type：string 类型为字符串最小长度；number 类型时为最小值；array 类型时为数组最小长度'),
      max: z
        .number()
        .optional()
        .describe('必须设置 type：string 类型为字符串最大长度；number 类型时为最大值；array 类型时为数组最大长度'),
    })
    .array()
    .optional()
    .describe('表单校验规则'),
})

export type FormItemSchema = z.infer<typeof formItemSchema>
